export default __webpack_public_path__ + "static/media/blue-arrow.dce9cda1.svg";